// AE,DS,MC,VI
export const card_type_options = [
  { value: 'mastercard', label: 'MasterCard' },
  { value: 'visa', label: 'Visa' },
  { value: 'american-express', label: 'American Express' },
  { value: 'discover', label: 'Discover' },
  { value: 'maestro', label: 'Maestro' },
  { value: 'unionpay', label: 'UnionPay' },
  { value: 'jcb', label: 'JCB' },
]
